import React from "react";
import "./Ticketing.css";


const TicketHistory = ({ history }) => {
  return (
    <div>
      <h6 className="form-label"><strong>History</strong></h6>

      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead>
            <tr className="history-table-header">
              <th>Time</th>
              {/* <th>Change</th> */}
              <th>Changed By</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {history?.length > 0 ? (
              history.map((item) => (
                <tr key={item.id}>
                  <td>{item.changed_at}</td>
                  {/* <td>{item.change_type}</td> */}
                  <td>{item.changed_by_name}</td>
                  <td dangerouslySetInnerHTML={{ __html: item.change_description }} />
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  No history available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TicketHistory;
